import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import ClassGroup from "./ClassGroup";
import { showWebView,hideSideBar } from "../../store/actions/ui.action";
const ClassFeedWebView = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showWebView());
    dispatch(hideSideBar())
  });
  return <ClassGroup {...props} />;
};

export default ClassFeedWebView;
